module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "PART-TITLE"
  }, [_vm._v("The Gallery")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Michelle, Cécile and Sylvie have created over 40 flowers, appliqués, badges, patches and other fun and bright motifs for you to use to personalise clothing and acessories for you and your family and to give as decorative gifts. Brighten up a little cardigan with a hedgehog for your tiny tot, make a statement of your shopping bag with a crochet badge, give a food lover’s key ring to your gourmet friend, or bring to life a plain scarf with bright, floral motifs.")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Their playful and quirky creations bring together lavish colour combinations with classic themes inspired by their travels to countries such as India, nature and everyday life. Let your imagination inspire you to use the motifs to brighten up your life!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d977fc0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 63
// module chunks = 0